import React from 'react';
import styled from 'styled-components';

export const ShippingFilterState = {
  MADE_TO_ORDER: 'madeToOrder',
  QUICK_SHIP: 'quickShip'
};
export default function QuickShipSwitch({
  className,
  shippingFilter,
  handleSetShippingFilter
}) {
  return (
    <Container className={className}>
      <Wrapper>
        <PrettyButton
          isActive={shippingFilter === ShippingFilterState.MADE_TO_ORDER}
          className="made-to-order"
          text="made to order"
          onClick={() => handleSetShippingFilter(ShippingFilterState.MADE_TO_ORDER)}
        />

        <PrettyButton
          isActive={shippingFilter === ShippingFilterState.QUICK_SHIP}
          className="quick-ship"
          text="quick ship"
          onClick={() => handleSetShippingFilter(ShippingFilterState.QUICK_SHIP)}
        />
      </Wrapper>
    </Container>
  );
}

function PrettyButton({ isActive, className, text, onClick }) {
  return (
    <button
      type="button"
      className={`${className} ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
}

const Container = styled.div`
  display: flex;
  margin: 0 20px;
  padding: 22.5px 0;
  button {
    background-color: transparent;
    border: none;
    display: flex;
    color: rgba(23, 23, 23, 0.5);
    align-items: center;
    justify-content: center;
    font-family: ${props => props.theme.fonts.primary};
    font-size: 13px;
    height: 39px;
    letter-spacing: 1.56px;
    line-height: 1.23;
    padding: 0;
    text-align: left;
    text-transform: uppercase;
    font-weight: 600;
  }

  .active {
    border: solid 1px #d9d9d9;
    background-color: ${({ theme }) => theme.colors.white};
    color: #171717;
    z-index: 1;
    border-radius: 24px;
  }

  .quick-ship {
    width: 160px;
    &.active {
      margin-left: -5px;
    }
  }

  .made-to-order {
    width: 180px;
    &.active {
      margin-left: -20px;
    }
  }
`;

const Wrapper = styled.div`
  background-color: #D9D9D9;
  border-radius: 24px;
  display: flex;
`;
